<template>
  <el-table-column :label="label" :prop="prop" class-name="weight" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '重量'
    },
    prop: {
      type: String,
      default: 'weight'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.weight {
      width: 8em;
    }
  }
  td.weight {
    text-align: right;
  }
}
</style>
